import { z } from 'zod';
import { pipelineSnapshotCountsSchema } from '../posts/pipeline-snapshot';

export const clientAreaPipelineSnapshotSchema = z.object({
  month: z.string(),
  counts: pipelineSnapshotCountsSchema,
});

export type ClientAreaPipelineSnapshotSchema = z.infer<typeof clientAreaPipelineSnapshotSchema>;
